import React from 'react'
import { useTranslation } from 'react-i18next'
import { SignInDataLayers } from '../../../../constants/gtm-events/gtm-events-sign-in'
import { CustomButton } from './mixins'

const Component = () => {
  const { t } = useTranslation()

  const onClick = async () => {
    await SignInDataLayers.clickSoyPostulante()
    window.location.assign('/')
  }

  return (
    <CustomButton
      onClick={onClick}
      buttonoptions={{
        type: 'link',
        size: 'small',
        variant: 'primary',
      }}
    >
      {t('signIn.applicant')}
    </CustomButton>
  )
}

export default Component
